export const releases = [
  {
    id: "1",
    name: "Больше чем того требует справедливость",
    imglink: "/music-releases/2_track.webp",
    links: {
      applemusic:
        "https://music.apple.com/ru/album/%D0%B1%D0%BE%D0%BB%D1%8C%D1%88%D0%B5-%D1%87%D0%B5%D0%BC-%D1%82%D0%BE%D0%B3%D0%BE-%D1%82%D1%80%D0%B5%D0%B1%D1%83%D0%B5%D1%82-%D1%81%D0%BF%D1%80%D0%B0%D0%B2%D0%B5%D0%B4%D0%BB%D0%B8%D0%B2%D0%BE%D1%81%D1%82%D1%8C-single/1728567721",
      yandex: "https://music.yandex.ru/album/29257035",
      spotify: "https://open.spotify.com/album/1e8BG81YvTQPJ2Cy7HHZhi",
      youtubemusic: "https://music.youtube.com/watch?v=ZLaS0psJOCw",
      vkmusic: "https://vk.com/audio474499173_456819747_0bffc8af4b1188af41",
      kionmusic: "https://music.mts.ru/album/29257035",
      zvuk: "https://zvuk.com/track/136374263?utm_referrer=https%3a%2f%2fsfm.click%2f",
      deezer: "https://www.deezer.com/ru/album/542209462",
      youtube: "",
    },
  },
  {
    id: "2",
    name: "Человеком стать",
    imglink: "/music-releases/1_track.webp",
    links: {
      applemusic:
        "https://music.apple.com/ru/album/%D1%87%D0%B5%D0%BB%D0%BE%D0%B2%D0%B5%D0%BA%D0%BE%D0%BC-%D1%81%D1%82%D0%B0%D1%82%D1%8C-single/1683510852",
      yandex: "https://music.yandex.ru/album/25598013/track/113199210",
      spotify: "https://open.spotify.com/track/54KNhoM3kWHhyNMUaZFYKr",
      youtubemusic:
        "https://music.youtube.com/watch?v=z6re6Qmoafw&si=3oplCnIV7lA8Y5Uf",
      vkmusic: "https://vk.com/audio474499275_456776190_52d4a78358ba6a1538",
      kionmusic: "https://mts-music-spo.onelink.me/sKFX/7f02v52b",
      zvuk: "https://zvuk.com/track/131147177",
      deezer: "https://link.deezer.com/s/32l2Gdoh1tQQLgfzxJ0m3",
      youtube: "",
    },
  },
  /* {
    name: "",
    imglink: "/music-releases/3_track.webp",
    links: {
      applemusic: "",
      vkmusic: "",
      yandex: "",
      spotify: "",
      mtcmusic: "",
      sberzvuk: "",
      deezer: "",
      youtubemusic: "",
      youtube: "",
    },
  }, */
];
